import type { SiteConfig } from '@/types'

const PLACEHOLDER = 'REPLACE_ME'

const rawSiteUrl = (process.env.NEXT_PUBLIC_SITE_URL ?? '').trim()

/**
 * The site's public address, used for canonical links, Open Graph URLs,
 * the sitemap and every JSON-LD identifier. Empty until it is configured,
 * so we never emit a wrong absolute URL.
 */
export const siteUrl =
    rawSiteUrl && rawSiteUrl !== PLACEHOLDER ? rawSiteUrl.replace(/\/+$/, '') : ''

export const absoluteUrl = (path = '/'): string => {
    if (!siteUrl) return ''
    if (!path || path === '/') return siteUrl

    return `${siteUrl}${path.startsWith('/') ? path : `/${path}`}`
}

export const siteConfig: SiteConfig = {
    name: 'Instituti Germa',
    description:
        'Instituti Germa është institucion kulturor e edukativo-arsimor, që vepron në fushën e botimeve, përkthimeve dhe kurseve të Kuranit e të gjuhëve të huaja.',
    url: siteUrl,
    ogImage: 'https://germa.cdn.modulify.website/social/igerma-og.jpg'
}
